import React from 'react';
import { Eyebrow } from './Eyebrow';
export function BrandSection() {
  return <section className="bg-sage-deep py-12 md:py-20 px-4" data-id="element-21" data-mp="2naxg6x947rws">
      <div className="max-w-2xl mx-auto text-center" data-id="element-22" data-mp="2n9dyr3bq3atf">
        <Eyebrow tone="dark" data-id="element-23" data-mp="2ib2st3ojtkgh">Pausa Propia</Eyebrow>
        <h2 className="mt-3 md:mt-4 font-serif text-[1.6rem] md:text-4xl lg:text-5xl font-bold text-ivory leading-[1.12] md:leading-tight" data-id="element-24" data-mp="2idowgs8bjftf">
          Porque hay días en los que ya pensaste suficiente.
        </h2>
        <p className="mt-4 font-sans text-[15px] md:text-lg text-ivory/85 leading-[1.6]" data-id="element-25" data-mp="3b22uh7zeqc4z">
          No todo tiene que empezar con otra pregunta o una página llena de palabras. A veces puedes
          empezar con un color. Una línea. Una pincelada. Una hoja que transformas con tus manos.
        </p>

        <p className="mt-8 md:mt-10 font-serif text-2xl md:text-4xl font-bold text-ivory leading-snug" data-id="element-26" data-mp="2w9j4l919q15h">
          El arte no es el resultado.
          <br data-id="element-27" data-mp="3oyzvu3d5jc04" />
          <span className="italic" data-id="element-28" data-mp="3oz9ef5vvagvs">El arte es la experiencia.</span>
        </p>

        <p className="mt-6 font-serif text-lg font-bold text-ivory" data-id="element-29" data-mp="25cbrnpsxrvjq">Pausa Propia</p>
        <p className="font-sans text-xs text-ivory/70" data-id="element-30" data-mp="29ddra7qrm9m8">por Nerovix</p>
      </div>
    </section>;
}